export default __webpack_public_path__ + "resources/icons/d212-6693.png";